export function formatScreenLock(lock?: { hours?: number; minutes?: number }) {
  if (!lock) return 'Sin límite'
  const h = lock.hours ?? 0
  const m = lock.minutes ?? 0
  if (h === 0 && m === 0) return 'Sin límite'
  return `${h}h ${m}m`
}

export function shortNumber(s?: string) {
  return s ?? '—'
}

export function appInitial(name?: string) {
  return (name ?? '?').charAt(0).toUpperCase()
}

export function timeAgo(timestamp?: string | number) {
  if (!timestamp) return '—'
  const t = typeof timestamp === 'number' ? timestamp : Date.parse(timestamp)
  if (isNaN(t)) return '—'
  const diff = Date.now() - t
  const min = Math.floor(diff / 60000)
  if (min < 1) return 'hace un momento'
  if (min < 60) return `hace ${min} min`
  const h = Math.floor(min / 60)
  if (h < 24) return `hace ${h} h`
  return new Date(t).toLocaleDateString('es')
}

export function isOnline(lastSeen?: string, withinMinutes = 5) {
  if (!lastSeen) return false
  const t = Date.parse(lastSeen)
  if (isNaN(t)) return false
  return Date.now() - t < withinMinutes * 60000
}
